<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only>
            <slot name="read_only">
                {{ display_value }}
            </slot>
        </template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>

        <base-date-input
            v-bind="$props"
            v-on="$listeners"
        />
    </form-group>
</template>

<script>
import is_nibnut_component from "../../mixins/IsNibnutComponent"

import FormGroup from "./FormGroup"
import BaseDateInput from "./BaseDateInput"

export default {
    name: "FormDateInput",
    mixins: [is_nibnut_component],
    components: {
        FormGroup,
        BaseDateInput
    },
    methods: {
    },
    computed: {
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: ""
        },
        required: {
            type: Boolean,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    }
}
</script>
